import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47d1afb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "postcode-search" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, [
  /*#__PURE__*/_createTextVNode("Search "),
  /*#__PURE__*/_createElementVNode("span", { clas: "title" }, "(Enter Suburb name or Postcode to search)")
], -1))
const _hoisted_3 = { class: "flex-row autocomplete pa-0 mt-1" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_6 = {
  key: 1,
  class: "fal fa-search"
}
const _hoisted_7 = {
  key: 0,
  id: "autocomplete-results",
  class: "autocomplete-results"
}
const _hoisted_8 = ["onClick", "innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_10 = { class: "flex-row" }
const _hoisted_11 = { style: {"flex":"5"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Suburb", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode("Required field. ")
], -1))
const _hoisted_14 = { style: {"flex":"2"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Postcode", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode("Required field. ")
], -1))
const _hoisted_17 = { style: {"flex":"3"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "State", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode("Required field. ")
], -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        class: "col-12 ma-0",
        style: {"width":"100%"},
        type: "text",
        ref: "suburbSearch",
        autocomplete: "new-name",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.query) = $event)),
        maxlength: "50",
        onInput: _cache[1] || (_cache[1] = $event => (_ctx.formDirty = true)),
        onKeydown: [
          _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
          _cache[3] || (_cache[3] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
          _cache[4] || (_cache[4] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
        ],
        placeholder: "Enter Suburb name or Postcode"
      }, null, 544), [
        [_vModelText, _ctx.query]
      ]),
      _createElementVNode("span", _hoisted_4, [
        (_ctx.isSearching)
          ? (_openBlock(), _createElementBlock("i", _hoisted_5))
          : (_openBlock(), _createElementBlock("i", _hoisted_6))
      ]),
      (_ctx.isOpen && _ctx.suburbList.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suburbList, (suburb, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i,
                onClick: $event => (_ctx.selectSuburbFromSearch(suburb)),
                class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]),
                innerHTML: _ctx.highlightWord(suburb.postcode + ', ' + suburb.suburbName.trim() + ', ' + suburb.stateName)
              }, null, 10, _hoisted_8))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(["input-box read-only", {error: _ctx.suburbError}])
        }, [
          _hoisted_12,
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.$refs['suburbSearch'].focus()))
          }, _toDisplayString(_ctx.suburbName), 1),
          _hoisted_13
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: _normalizeClass(["input-box read-only", {error: _ctx.suburbError}])
        }, [
          _hoisted_15,
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = $event => (_ctx.$refs['suburbSearch'].focus()))
          }, _toDisplayString(_ctx.postcode), 1),
          _hoisted_16
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: _normalizeClass(["input-box read-only", {error: _ctx.suburbError}])
        }, [
          _hoisted_18,
          _createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = $event => (_ctx.$refs['suburbSearch'].focus()))
          }, _toDisplayString(_ctx.stateName), 1),
          _hoisted_19
        ], 2)
      ])
    ])
  ]))
}